import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import DakotaChat from "./pages/DakotaChat";
import Tests from "./pages/Tests";
import Resources from "./pages/Resources";
import Notes from "./pages/Notes";
import BlogPage from "./pages/BlogPage";
import Groups from "./pages/Groups";
import Communication from "./pages/Communication";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Links from "./pages/Links";
import Recommendations from "./pages/Recommendations";
import PracticalExams from "./pages/PracticalExams";
import Messages from "./pages/Messages";
import DriveLibrary from "./pages/DriveLibrary";
import DrivePlayer from "./pages/DrivePlayer";
import CompetencyMap from "./pages/CompetencyMap";
import CookieConsent from "./components/CookieConsent";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-neutral-500">Cargando…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = "Acceso Natur Autoescuela";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/app" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="dakota" element={<DakotaChat />} />
              <Route path="tests" element={<Tests />} />
              <Route path="recursos" element={<Resources kind="recursos" />} />
              <Route path="multimedia" element={<Resources kind="multimedia" />} />
              <Route path="notas" element={<Notes />} />
              <Route path="blog" element={<BlogPage />} />
              <Route path="comunidad" element={<Groups />} />
              <Route path="comunicacion" element={<Communication />} />
              <Route path="perfil" element={<Profile />} />
              <Route path="gestion" element={<Admin />} />
              <Route path="enlaces" element={<Links />} />
              <Route path="recomendados" element={<Recommendations />} />
              <Route path="examenes" element={<PracticalExams />} />
              <Route path="competencias" element={<CompetencyMap />} />
              <Route path="mensajes" element={<Messages />} />
              <Route path="academia/drive" element={<DriveLibrary />} />
              <Route path="academia/drive/:lessonId" element={<DrivePlayer />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <CookieConsent />
      </AuthProvider>
    </div>
  );
}

export default App;
